import { createSlice } from "@reduxjs/toolkit";
import config from "../config";
import { reducerLoadInitialUserController } from "../controllers/reducerController.js";

const initialState = {
  user: reducerLoadInitialUserController() || null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
      if (action.payload) {
        localStorage.setItem(
          config.localStorage.user,
          JSON.stringify(action.payload)
        );
      } else {
        localStorage.removeItem(config.localStorage.user);
      }
    },
    logout: (state, action) => {
      state.user = null;
      localStorage.removeItem(config.localStorage.user);
    },
  },
});

export const { setUser, logout } = userSlice.actions;
export default userSlice.reducer;
